import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth, db } from "../../firebase/config";
import { doc, getDoc, serverTimestamp } from "firebase/firestore";

export async function SignWithGoogle() {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  const user = result.user;

  const userData = {
    fullName: user.displayName,
    photoURL: user.photoURL,
    email: user.email,
    uid: user.uid,

    createdAt: serverTimestamp(),
    token: await user.getIdToken()
  };
  const docRef = doc(db, "users", user.uid);
  const snapShot = await getDoc(docRef);

  return { userData, snapShot, docRef };
}
